// extracted by mini-css-extract-plugin
export var completionBody = "_js-2";
export var completionCard = "_js-0";
export var completionFooter = "_js-3";
export var completionTitle = "_js-1";